import { cx } from '@eti/styles';
import { useEffect, useRef, useState } from 'react';
import { useProductCardContext } from '../../context/ProductCardContext';
import { canvasStyles, standardGrid } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Illustration = _ref => {
  let {
    customGrid,
    children,
    className
  } = _ref;
  const {
    productName,
    illustrationUrl
  } = useProductCardContext();
  const [illustrationHeight, setIllustrationHeight] = useState(10000);
  const illustrationElement = useRef(null);
  useEffect(() => {
    var _illustrationElement$;
    if ((_illustrationElement$ = illustrationElement.current) !== null && _illustrationElement$ !== void 0 && _illustrationElement$.offsetHeight) {
      var _illustrationElement$2;
      setIllustrationHeight(((_illustrationElement$2 = illustrationElement.current) === null || _illustrationElement$2 === void 0 ? void 0 : _illustrationElement$2.offsetHeight) - 1);
    }
  }, [illustrationElement]);
  return /*#__PURE__*/_jsxs("div", {
    className: cx('product-image', className, customGrid || standardGrid),
    "data-testid": "illustration-container",
    children: [/*#__PURE__*/_jsx("div", {
      className: cx(canvasStyles(illustrationUrl, illustrationHeight), 'canvas'),
      "data-testid": `illustration-${productName}`,
      ref: illustrationElement
    }), children && /*#__PURE__*/_jsx("div", {
      className: "children",
      "data-testid": "illustration-children",
      children: children
    })]
  });
};
export default Illustration;
//# sourceMappingURL=Illustration.js.map